import { ATTRIBUTION_TAB_IDS } from './consts';

const { GENERAL, TRACKING_LINK_OPTIONS, POSTBACK_OVERALL_SETUP, POSTBACK_TEMPLATES } = ATTRIBUTION_TAB_IDS;

// Validator suffix variants that all point to the same on-page anchor.
const FIELD_TO_ANCHOR = {
    [GENERAL]: {
        platform_template: 'platform_template',
        platforms: 'platforms',
        platforms_other: 'platforms',
        campaign_objectives: 'campaign_objectives',
        installs_data_scope: 'installs_data_scope',
        events_data_scope: 'events_data_scope',
    },
    [TRACKING_LINK_OPTIONS]: {
        view_through_campaigns: 'view_through_campaigns',
        click_impression_reporting_method: 'click_impression_reporting_method',
        click_impression_reporting_method_elaboration: 'click_impression_reporting_method',
        tracking_link_parameters: 'tracking_link_parameters',
        tracking_link_parameters_item_fields: 'tracking_link_parameters',
        tracking_link_parameters_macro_required: 'tracking_link_parameters',
        tracking_link_parameters_macro_invalid_chars: 'tracking_link_parameters',
        tracking_link_parameters_duplicate_key: 'tracking_link_parameters',
        tracking_link_parameters_server_side: 'tracking_link_parameters',
        tracking_link_extra: 'tracking_link_parameters',
    },
    [POSTBACK_OVERALL_SETUP]: {
        postback_events_and_platforms: 'postback_events_and_platforms',
        postback_url_base: 'postback_url_base',
        postback_url_domain: 'postback_url_base',
        postback_url_domain_invalid: 'postback_url_base',
        postback_url_security_token_invalid: 'postback_url_base',
        postback_url_required_query_param: 'postback_url_base',
        postback_url_required_query_param_invalid: 'postback_url_base',
        postback_urls: 'postback_urls',
        postback_urls_invalid_domain: 'postback_urls',
        app_level_macros: 'app_level_macros',
        event_parameter_key_name: 'event_mapping',
        event_parameter_key_no_spaces: 'event_mapping',
        event_names: 'event_mapping',
        event_names_empty: 'event_mapping',
        event_names_no_spaces: 'event_mapping',
        event_names_duplicate: 'event_mapping',
    },
};

const PREFIX_TO_ANCHOR = {
    [TRACKING_LINK_OPTIONS]: [['tracking_link_parameters.', 'tracking_link_parameters']],
    [POSTBACK_OVERALL_SETUP]: [['app_level_macros.', 'app_level_macros']],
};

const KNOWN_TAB_IDS = new Set(Object.values(ATTRIBUTION_TAB_IDS));

export const getErrorAnchor = errorKey => {
    if (!errorKey || typeof errorKey !== 'string') return null;
    const parts = errorKey.split('.');
    if (parts.length < 3 || parts[0] !== 'formData') return null;
    const tabId = parts[1];
    if (!KNOWN_TAB_IDS.has(tabId)) return null;

    if (tabId === POSTBACK_TEMPLATES) {
        if (parts.length < 5) return null;
        const [, , eventType, platform] = parts;
        return { tabId, anchor: `postback_template_${eventType}_${platform}` };
    }

    const fieldPath = parts.slice(2).join('.');
    const exact = FIELD_TO_ANCHOR[tabId]?.[fieldPath];
    if (exact) return { tabId, anchor: exact };

    const prefixes = PREFIX_TO_ANCHOR[tabId] || [];
    for (const [prefix, anchor] of prefixes) {
        if (fieldPath.startsWith(prefix)) return { tabId, anchor };
    }

    return { tabId, anchor: parts[2] };
};
